/* ============================================================
   ctr-timeline — week tabs switching.
   ============================================================ */

(function () {
  'use strict';

  function initSection(root) {
    if (root.dataset.ctrTlInit) return;
    root.dataset.ctrTlInit = 'true';

    var tabs = root.querySelectorAll('[data-ctr-tab]');
    var panels = root.querySelectorAll('[data-ctr-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.dataset.ctrTab;

        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.dataset.ctrPanel === key);
        });
      });
    });
  }

  function initAllSections() {
    document.querySelectorAll('[data-ctr-timeline]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', initAllSections);
})();
